import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { useStateContext } from "../../global-context/useGlobalContext";

const WhatSection = () => {
  const { language } = useStateContext();
  return (
    <WhatWrapper>
      <LeftSpace></LeftSpace>
      <WhatText>
        <h1>{language ? <span>Quoi?</span> : <span>What?</span>}</h1>
        {language ? (
          <p>
            Nous développons votre site internet, rapide et adapté pour votre
            téléphone, votre ordinateur et aux standards d’aujourd’hui. Des
            besoins en communication visuelle? Nous créons également des
            supports de communication imprimés (flyers, dépliants, brochures,
            affiches, cartes de visite) ou numériques (design de logos,
            templates pour médias sociaux).
          </p>
        ) : (
          <p>
            We develop your website, fast, responsive, adequate to today’s
            standards. Need some visuals? We also create printed communication
            tools (flyers, brochures, business cards, posters) or numeric
            communication tools (logo design, social media templates)
          </p>
        )}
      </WhatText>
    </WhatWrapper>
  );
};

export default WhatSection;

const WhatWrapper = styled(motion.div)`
  flex: 1;
  width: 100vw;
  height: 100vh;
  padding: 0 10vw;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background: none;
  color: white;
  h1 {
    font-size: 3rem;
    color: #83c5be;
  }
  p {
    font-size: 1.5rem;
    padding-top: 4rem;
    line-height: 150%;
  }
  @media (max-width: 950px) {
    padding: 10rem 2.5rem;
    height: fit-content;
  }
`;
const WhatText = styled.div`
  flex: 1;
  @media (max-width: 950px) {
    flex: 2;
  }
`;

const LeftSpace = styled.div`
  flex: 1;
  @media (max-width: 950px) {
    flex: 0;
  }
`;
